import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  size?: 'lg' | 'xl';
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  size = 'lg',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-oswald uppercase tracking-wider font-bold transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-gold-500 text-navy-950 hover:bg-gold-400 shadow-[0_0_20px_rgba(242,193,78,0.3)] hover:shadow-[0_0_30px_rgba(242,193,78,0.5)]',
    secondary: 'bg-navy-800 text-white border border-navy-700 hover:bg-navy-700 hover:border-gold-500/50'
  };
  const sizes = {
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const width = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} rounded-lg ${className}`} {...props} data-id="element-228">
      <span className="relative z-10 flex items-center gap-2" data-id="element-229">
        {children}
        <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-230" />
      </span>
      <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-231" />
    </motion.button>;
}